import React from 'react';
import { QuoteIcon } from 'lucide-react';
export function SequenceUseCases() {
  return <section className="py-24 bg-white border-t border-slate-100" data-id="element-1635">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1636">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-1637">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6 leading-tight" data-id="element-1638">
            Email sequence software for{' '}
            <span className="text-blue-600" data-id="element-1639">every team</span>
          </h2>
          <p className="text-xl text-slate-600 leading-relaxed" data-id="element-1640">
            See how B2B sales teams use our automated outreach to book more
            meetings with local businesses.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1641">
          <div className="bg-slate-50 rounded-3xl p-8 flex flex-col justify-between" data-id="element-1642">
            <div data-id="element-1643">
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-1644">
                Sales prospecting
              </h3>
              <p className="text-base text-slate-600 leading-relaxed" data-id="element-1645">
                SDRs use our B2B email sequence tools to automate their outreach
                to local business owners, freeing up time for actual selling.
              </p>
            </div>
            <div className="mt-8 pt-6 border-t border-slate-200" data-id="element-1646">
              <QuoteIcon className="w-5 h-5 text-blue-200 mb-2" data-id="element-1647" />
              <p className="text-base text-slate-700 italic leading-relaxed" data-id="element-1648">
                Having the lead data and email sequence CRM in one place doubled
                our booked meetings.
              </p>
              <p className="text-sm font-semibold text-slate-400 mt-3 uppercase tracking-wider" data-id="element-1649">
                — James T., Sales Director
              </p>
            </div>
          </div>

          <div className="bg-slate-50 rounded-3xl p-8 flex flex-col justify-between" data-id="element-1650">
            <div data-id="element-1651">
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-1652">
                Agency outreach
              </h3>
              <p className="text-base text-slate-600 leading-relaxed" data-id="element-1653">
                Marketing agencies use our platform to find local businesses
                with specific tech stacks and pitch them via automated
                sequences.
              </p>
            </div>
            <div className="mt-8 pt-6 border-t border-slate-200" data-id="element-1654">
              <QuoteIcon className="w-5 h-5 text-blue-200 mb-2" data-id="element-1655" />
              <p className="text-base text-slate-700 italic leading-relaxed" data-id="element-1656">
                The best email sequence software for sales teams targeting
                brick-and-mortar clients.
              </p>
              <p className="text-sm font-semibold text-slate-400 mt-3 uppercase tracking-wider" data-id="element-1657">
                — Sarah M., Agency Founder
              </p>
            </div>
          </div>

          <div className="bg-slate-50 rounded-3xl p-8 flex flex-col justify-between" data-id="element-1658">
            <div data-id="element-1659">
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-1660">
                CRM integration
              </h3>
              <p className="text-base text-slate-600 leading-relaxed" data-id="element-1661">
                RevOps teams love how our platform logs CRM sequences emails
                calls directly into Salesforce and HubSpot automatically.
              </p>
            </div>
            <div className="mt-8 pt-6 border-t border-slate-200" data-id="element-1662">
              <QuoteIcon className="w-5 h-5 text-blue-200 mb-2" data-id="element-1663" />
              <p className="text-base text-slate-700 italic leading-relaxed" data-id="element-1664">
                Replaced our expensive HubSpot email sequences add-on and got
                better local data included.
              </p>
              <p className="text-sm font-semibold text-slate-400 mt-3 uppercase tracking-wider" data-id="element-1665">
                — David L., RevOps Manager
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}